<script>
	let display = false;
</script>

<div on:click={() => {display = !display}} class="infoicon">
	<img src="./info.png" width="30px" height="30px">
</div>

{#if display}
	<div class="infobox">
		<p><b>How population density has changed across Denmark</b>.<br><br>
		Each bar represents a geographical region, roughly 1.5 km by 1.5 km in size.
		The <b>height</b> of a bar represents its baseline population: the typical number of people inside it during a similar time period in the past.
		The <b>color</b> represents the observed change during lockdown, measured as the percentage deviation.
		On most days, you will see that cities (where bars are tall) are less populated than usual (thus bars are red).
		At the same time, sparsely populated regions near the coast become more populated (green bars).
		</p>
		<blockquote>Hold down the <kbd>shift</kbd> (or <kbd>alt</kbd>) key while panning the map to change perspective. Scroll to zoom.</blockquote>
	</div> 
{/if}

<style>
	p {
		margin: 15px;
		text-align: justify;
		font-family: sans-serif;
		hyphens: auto;
	}
	img {
		cursor: pointer;
	}
	.infoicon {
		margin-top: 70px;
		margin-left: 10px;
		opacity: 0.5;
		z-index: 1;
	}
	.infobox {
		position: relative;
		width: 250px;
		margin-top: -33px;
		margin-left: 45px;
		background-color: white;
		opacity: 0.8;
		border-style: solid;
		border-width: 2px;
		border-radius: 3px;
		border-color: #999999;
		z-index: 2;
	}
</style>